module.exports = __webpack_public_path__ + "static/media/sec1logo3.ab8961ed.svg";